import {
  CreateAttendanceBreakConfigurationDocument,
  CreateAttendanceBreakConfigurationMutationVariables,
  GetTimeSettingsBreakConfigurationsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAttendanceBreakConfiguration = () => {
  const [createConfiguration, { loading }] = useMutation(
    CreateAttendanceBreakConfigurationDocument,
    {
      extractorFn: (data) => data.attendanceMutations.createAttendanceBreakConfiguration,
    }
  )

  const create = (variables: CreateAttendanceBreakConfigurationMutationVariables) => {
    return createConfiguration({
      variables,
      refetchQueries: [GetTimeSettingsBreakConfigurationsDocument],
    })
  }

  return {
    loading,
    create,
  }
}
